var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicantNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2C11.3125 2 12 2.6875 12 3.5V14.5C12 15.3438 11.3125 16 10.5 16H1.5C0.65625 16 0 15.3438 0 14.5V3.5C0 2.6875 0.65625 2 1.5 2H4C4 0.90625 4.875 0 6 0C7.09375 0 8 0.90625 8 2H10.5ZM6 1.25C5.5625 1.25 5.25 1.59375 5.25 2C5.25 2.4375 5.5625 2.75 6 2.75C6.40625 2.75 6.75 2.4375 6.75 2C6.75 1.59375 6.40625 1.25 6 1.25ZM10.5 14.3125V3.6875C10.5 3.59375 10.4062 3.5 10.3125 3.5H9V4.625C9 4.84375 8.8125 5 8.625 5H3.375C3.15625 5 3 4.84375 3 4.625V3.5H1.6875C1.5625 3.5 1.5 3.59375 1.5 3.6875V14.3125C1.5 14.4375 1.5625 14.5 1.6875 14.5H10.3125C10.4062 14.5 10.5 14.4375 10.5 14.3125Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantNote);
export default __webpack_public_path__ + "static/media/applicant-note.7a30e3ab.svg";
export { ForwardRef as ReactComponent };